import { pick } from 'ramda'

import { TAX_FIELDS } from '../../components/Tax/TaxCreateForm'

export const TaxCreateSerializer = formValues => {
  return pick(TAX_FIELDS, formValues)
}
